const EMIT_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_load",
};

const EMIT_LOAD_PRODUCT_PAYLINK = {
  tcclEvent: "gdp.hub.opl_c2_load_product_paylink",
};

const EMIT_LOAD_PRODUCT_PAYLINK_CHECKOUT = {
  tcclEvent: "gdp.hub.opl_c2_load_product_paylink_checkout",
};

const EMIT_LOAD_FIXED_AMOUNT = {
  tcclEvent: "gdp.hub.opl_c2_load_fixed_amount",
};

const EMIT_LOAD_CUSTOM_AMOUNT = {
  tcclEvent: "gdp.hub.opl_c2_load_custom_amount",
};

const EMIT_LOAD_LEGACY_OPTIONS = {
  tcclEvent: "gdp.hub.opl_c2_load_legacy_options",
};

const EMIT_LOAD_OPTIONS = {
  tcclEvent: "gdp.hub.opl_c2_load_options",
};

const EMIT_LOAD_BUSINESS_INFO = {
  tcclEvent: "gdp.hub.opl_c2_load_business_info",
};

const EMIT_LOAD_PRODUCT = {
  tcclEvent: "gdp.hub.opl_c2_load_product",
};

const EMIT_LOAD_CATALOG = {
  tcclEvent: "gdp.hub.opl_c2_load_catalog",
};

const EMIT_LOAD_CATALOG_ADD_PRODUCT = {
  tcclEvent: "gdp.hub.opl_c2_load_catalog_add_product",
};

const EMIT_LOAD_INVOICE = {
  tcclEvent: "gdp.hub.opl_c2_load_invoice",
};

const EMIT_LOAD_PDF_DOWNLOAD_BUTTON = {
  tcclEvent: "gdp.hub.opl_c2_load_pdf_download_button",
};

const EMIT_LOAD_PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON = {
  tcclEvent: "gdp.hub.opl_c2_load_pdf_download_confirmation_page_button",
};

const EMIT_LOAD_PRODUCT_CHECKOUT = {
  tcclEvent: "gdp.hub.opl_c2_load_product_checkout",
};

const EMIT_LOAD_CHECKOUT = {
  tcclEvent: "gdp.hub.opl_c2_load_checkout",
};

const EMIT_LOAD_CATALOG_CHECKOUT = {
  tcclEvent: "gdp.hub.opl_c2_load_catalog_checkout",
};

const EMIT_LOAD_COMPLETE = {
  tcclEvent: "gdp.hub.opl_c2_load_complete",
};

const EMIT_LOAD_ATTACHMENT = {
  tcclEvent: "gdp.hub.opl_c2_load_invoice_attachment",
};

const EMIT_PAY_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_save.button.click",
};

const EMIT_COLLECT_ERROR = {
  tcclEvent: "gdp.hub.opl_c2_collect_error",
};

const EMIT_SUCCESS = {
  tcclEvent: "gdp.hub.opl_c2_success",
};

const EMIT_OPTION = {
  tcclEvent: "gdp.hub.opl_c2_option.click",
};

const EMIT_NOTE = {
  tcclEvent: "gdp.hub.opl_c2_notebox.click",
};

const EMIT_CURRENCY = {
  tcclEvent: "gdp.hub.opl_c2_amount.click",
};

const SURCHARGE_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_surcharge_load",
};

const SURCHARGE_CANCEL_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_surcharge_cancel_button.click",
};

const SURCHARGE_CONFIRM_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_surcharge_confirm_button.click",
};

const DEFAULT_CARD_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_default_card_payment_method_load",
};

const DEFAULT_CARD_WITH_SURCHARGE_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_default_card_with_surcharge_payment_method_load",
};

const DEFAULT_ACH_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_default_ach_payment_method_load",
};

const CARD_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_card_payment_method_load",
};

const CARD_ONLY_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_card_only_payment_method_load",
};

const ACH_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_ach_payment_method_load",
};

const ACH_ONLY_PAYMENT_METHOD_LOAD = {
  tcclEvent: "gdp.hub.opl_c2_ach_only_payment_method_load",
};

const ACH_PAYMENT_METHOD_SELECTED = {
  tcclEvent: "gdp.hub.opl_c2_ach_payment_method_selected",
};

const CARD_PAYMENT_METHOD_SELECTED = {
  tcclEvent: "gdp.hub.opl_c2_card_payment_method_selected",
};

const CARD_TRANSACTION_SUCCESS = {
  tcclEvent: "gdp.hub.opl_c2_card_transaction_success",
};

const ACH_TRANSACTION_SUCCESS = {
  tcclEvent: "gdp.hub.opl_c2_ach_transaction_success",
};

const CARD_TRANSACTION_FAILURE = {
  tcclEvent: "gdp.hub.opl_c2_card_transaction_failure",
};

const ACH_TRANSACTION_FAILURE = {
  tcclEvent: "gdp.hub.opl_c2_ach_transaction_failure",
};

const FIELD_INPUT_FOCUSED = {
  tcclEvent: "gdp.hub.opl_c2_field_input_focused",
};

const CARD_ON_FILE_FLAG_CHANGED = {
  tcclEvent: "gdp.hub.opl_c2_card_on_file_flag_changed",
};

const PDF_DOWNLOAD_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_pdf_download_button.click",
};

const PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_pdf_download_confirmation_page_button.click",
};

const ATTACHMENT_DOWNLOAD_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_attachment_download.click",
};

const GOOGLE_PAY_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_google_pay_button.click",
};

const APPLE_PAY_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_apple_pay_button.click",
};

const APPLE_PAY_QR_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_apple_pay_qr_button.click",
};

const PAZE_BUTTON_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_paze_button.click",
};

const APPLE_PAY_CLOSE = {
  tcclEvent: "gdp.hub.opl_c2_apple_pay_close",
}

const GOOGLE_PAY_CLOSE = {
  tcclEvent: "gdp.hub.opl_c2_google_pay_close",
}

const PAZE_CLOSE = {
  tcclEvent: "gdp.hub.opl_c2_paze_close",
}

const GOOGLE_PAY_ERROR = {
  tcclEvent: "gdp.hub.opl_c2_google_pay_error",
};

const APPLE_PAY_ERROR = {
  tcclEvent: "gdp.hub.opl_c2_apple_pay_error",
};

const PAZE_ERROR = {
  tcclEvent: "gdp.hub.opl_c2_paze_error",
};

const INVOICE_ITEM_IMAGE_CLICK = {
  tcclEvent: "gdp.hub.opl_c2_invoice_item_image.click",
};

const INVOICE_ITEM_IMAGE_DOWNLOAD = {
  tcclEvent: "gdp.hub.opl_c2_invoice_item_image_download.click",
};

const INVOICE_ITEM_IMAGE_DOWNLOAD_ERROR = {
  tcclEvent: "gdp.hub.opl_c2_invoice_item_image_download_error",
};

const PAYMENT_DISABLED_IMPRESSION = {
  tcclEvent: "gdp.hub.invoice_c2_payments_disabled.banner.impression",
}

export {
  EMIT_LOAD,
  EMIT_LOAD_FIXED_AMOUNT,
  EMIT_LOAD_CUSTOM_AMOUNT,
  EMIT_LOAD_LEGACY_OPTIONS,
  EMIT_LOAD_OPTIONS,
  EMIT_LOAD_BUSINESS_INFO,
  EMIT_LOAD_PRODUCT,
  EMIT_LOAD_CATALOG,
  EMIT_LOAD_CATALOG_ADD_PRODUCT,
  EMIT_LOAD_CATALOG_CHECKOUT,
  EMIT_LOAD_INVOICE,
  EMIT_LOAD_PDF_DOWNLOAD_BUTTON,
  EMIT_LOAD_PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON,
  EMIT_LOAD_PRODUCT_CHECKOUT,
  EMIT_LOAD_CHECKOUT,
  EMIT_LOAD_ATTACHMENT,
  EMIT_PAY_BUTTON_CLICK,
  EMIT_COLLECT_ERROR,
  EMIT_SUCCESS,
  EMIT_OPTION,
  EMIT_NOTE,
  EMIT_CURRENCY,
  EMIT_LOAD_COMPLETE,
  SURCHARGE_LOAD,
  SURCHARGE_CANCEL_BUTTON_CLICK,
  SURCHARGE_CONFIRM_BUTTON_CLICK,
  DEFAULT_CARD_PAYMENT_METHOD_LOAD,
  DEFAULT_CARD_WITH_SURCHARGE_PAYMENT_METHOD_LOAD,
  DEFAULT_ACH_PAYMENT_METHOD_LOAD,
  CARD_PAYMENT_METHOD_LOAD,
  CARD_ONLY_PAYMENT_METHOD_LOAD,
  ACH_PAYMENT_METHOD_LOAD,
  ACH_ONLY_PAYMENT_METHOD_LOAD,
  ACH_PAYMENT_METHOD_SELECTED,
  CARD_PAYMENT_METHOD_SELECTED,
  CARD_TRANSACTION_SUCCESS,
  ACH_TRANSACTION_SUCCESS,
  CARD_TRANSACTION_FAILURE,
  ACH_TRANSACTION_FAILURE,
  FIELD_INPUT_FOCUSED,
  CARD_ON_FILE_FLAG_CHANGED,
  PDF_DOWNLOAD_BUTTON_CLICK,
  PDF_DOWNLOAD_CONFIRMATION_PAGE_BUTTON_CLICK,
  ATTACHMENT_DOWNLOAD_CLICK,
  GOOGLE_PAY_BUTTON_CLICK,
  APPLE_PAY_BUTTON_CLICK,
  APPLE_PAY_QR_BUTTON_CLICK,
  PAZE_BUTTON_CLICK,
  APPLE_PAY_CLOSE,
  GOOGLE_PAY_CLOSE,
  PAZE_CLOSE,
  GOOGLE_PAY_ERROR,
  APPLE_PAY_ERROR,
  PAZE_ERROR,
  INVOICE_ITEM_IMAGE_CLICK,
  INVOICE_ITEM_IMAGE_DOWNLOAD,
  INVOICE_ITEM_IMAGE_DOWNLOAD_ERROR,
  PAYMENT_DISABLED_IMPRESSION,
  EMIT_LOAD_PRODUCT_PAYLINK,
  EMIT_LOAD_PRODUCT_PAYLINK_CHECKOUT,
};
